import { motion } from 'motion/react';
import { useEffect } from 'react';

import { SnackbarContent } from './SnackbarContent';
import { Snackbar as Props } from './types';
import { useSnackbar } from '../../../hooks/useSnackbar';

const MotionRoot = motion.div;

const DEFAULT_SNACKBAR_DURATION = 5000;

export const Snackbar = ({
  id,
  displayDuration = DEFAULT_SNACKBAR_DURATION,
  message,
  actionButtonText,
  actionButtonPosition,
  onActionClick,
  dataTestId,
}: Props) => {
  const { removeSnackbar } = useSnackbar();

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      removeSnackbar(id!);
    }, displayDuration);
    return () => clearTimeout(timeoutId);
  }, [id, removeSnackbar, displayDuration]);

  const handleActionClick = () => {
    if (!onActionClick) return;

    removeSnackbar(id!);
    onActionClick();
  };

  return (
    <MotionRoot
      initial={{ opacity: 0.5, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ scale: 0, opacity: 0, transition: { duration: 0.15 } }}
    >
      <SnackbarContent
        message={message}
        actionButtonPosition={actionButtonPosition}
        actionButtonText={actionButtonText}
        onActionClick={handleActionClick}
        dataTestId={dataTestId}
      />
    </MotionRoot>
  );
};
